var React = require('react');

function ProveItPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M35.2583 85.7205L24.7855 112.812L6.56011 90.1964L35.2583 85.7205Z","stroke":"#143673","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M179.013 111.647L130.816 148.7L122.825 88.4335L179.013 111.647Z","stroke":"#C99CEF","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M34.2104 9.3181L55.6617 14.1939L40.7135 30.3334L34.2104 9.3181Z","fill":"#C99CEF","key":2})]);
}

ProveItPolyclusterInline.defaultProps = {"width":"193","height":"165","viewBox":"0 0 193 165","fill":"none"};

module.exports = ProveItPolyclusterInline;

ProveItPolyclusterInline.default = ProveItPolyclusterInline;
